import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { AnimatedBackground } from '@/components/ui';

// Animation keyframes
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const slideInFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideInFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const backgroundMove = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

// Styled components matching the Regions design
const AuthContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  //background: theme.palette.primary.main,
  //backgroundSize: '200% 200%',
  //animation: `${backgroundMove} 8s ease infinite`,
  //padding: 0,
  //position: 'relative',
  // overflow: 'hidden',
  // '&::before': {
  //   content: '""',
  //   position: 'absolute',
  //   top: 0,
  //   left: 0,
  //   right: 0,
  //   bottom: 0,
  //   background:
  //     'radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.05) 0%, transparent 50%)',
  //   pointerEvents: 'none',
  // },
}));

const AuthWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  backgroundColor: 'white',
  borderRadius: theme.spacing(3),
  // boxShadow: theme.shadows[24],
  overflow: 'hidden',
  zIndex: 9,
  position: 'relative',
  // animation: `${fadeInUp} 0.8s ease-out`,
  // '& > *:first-of-type': {
  //   animation: `${slideInFromLeft} 0.6s ease-out 0.2s both`,
  // },
  // '& > *:last-of-type': {
  //   animation: `${slideInFromRight} 0.6s ease-out 0.4s both`,
  // },
  // [theme.breakpoints.down('md')]: {
  //   flexDirection: 'column',
  //   height: 'auto',
  //   maxWidth: '400px',
  //   borderRadius: theme.spacing(2),
  //   '& > *:first-of-type': {
  //     animation: `${slideInFromLeft} 0.6s ease-out 0.2s both`,
  //   },
  //   '& > *:last-of-type': {
  //     animation: `${slideInFromLeft} 0.6s ease-out 0.4s both`,
  //   },
  // },
}));

const AuthLayout: React.FC = () => {
  return (
    <AuthContainer>
      {/* Animated Background Graphics */}
      <AuthWrapper>
        <Outlet />
      </AuthWrapper>
      <AnimatedBackground theme="dark" intensity="medium" />  
    </AuthContainer>
  );
};

export default AuthLayout;
